import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function NotFound() {
  const { t } = useTranslation("common");
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-xs font-medium text-muted-foreground">404</p>
      <h1 className="text-lg font-semibold">{t("PAGE_NOT_FOUND")}</h1>
      <Button asChild variant="outline" size="sm">
        <Link to="/workspace">{t("BACK_TO_WORKSPACE")}</Link>
      </Button>
    </div>
  );
}

export const Component = NotFound;
